import {Component, Input, OnInit} from '@angular/core';
import {Resultate} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m2';

@Component({
  selector: 'app-mv-m2-table-resultate',
  templateUrl: './mv-m2-table-resultate.component.html',
  styleUrls: [
    './mv-m2-table-resultate.component.scss',
    '../../../../cockpit-shared/contents/cockpit-styles.scss'
  ],
  standalone: false
})
export class MvM2TableResultateComponent {
  @Input() data: Resultate;

  rowHeaderResultateResKeys = [
    'm2.sprint9.cockpit-kontrolle.modellvarianten.resultate.analyse-nur-mit-grundlohn',
    'm2.sprint9.cockpit-kontrolle.modellvarianten.resultate.analyse-mit-fixerGewichtung',
    'm2.sprint9.cockpit-kontrolle.modellvarianten.resultate.standard-Analysemodell'
  ];
}
